import styled from 'styled-components';
import { subtitle1, spacing } from 'ui/theme';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Dispatch, FC, SetStateAction } from 'react';
import { NoOp } from 'utils/noop';

const StyledModalBody = styled(ModalBody)`
  padding: ${spacing.double};
  ${subtitle1}
`;

type Props = {
  isDefaultFiltersModalOpen: boolean;
  setIsDefaultFiltersModalOpen: Dispatch<SetStateAction<boolean>>;
  saveDefaultFilters: NoOp;
};
export const DefaultFiltersModal: FC<React.PropsWithChildren<Props>> = ({
  isDefaultFiltersModalOpen,
  setIsDefaultFiltersModalOpen,
  saveDefaultFilters,
}) => {
  const closeModal = () => {
    setIsDefaultFiltersModalOpen(false);
  };
  return (
    <Modal
      id="exportModal"
      isModalOpen={isDefaultFiltersModalOpen}
      onClose={closeModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>Set as default filters for everyone?</ModalHeader>
      <StyledModalBody>
        Selected filters will become the default view for all team members in your project when they
        visit the Messaging Insights page
      </StyledModalBody>
      <ModalFooter>
        <Button
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
          onClick={() => {
            saveDefaultFilters();
            closeModal();
          }}
        >
          Set filters
        </Button>
      </ModalFooter>
    </Modal>
  );
};
